import { createContext, useContext, useState, useCallback, ReactNode } from "react";

const STORAGE_KEY = "devModeEnabled";

interface DevModeContextValue {
  devMode: boolean;
  enable: () => void;
  disable: () => void;
  toggle: () => void;
}

const DevModeContext = createContext<DevModeContextValue | null>(null);

export function DevModeProvider({ children }: { children: ReactNode }) {
  const [devMode, setDevMode] = useState<boolean>(() => localStorage.getItem(STORAGE_KEY) === "true");

  const persist = useCallback((value: boolean) => {
    setDevMode(value);
    localStorage.setItem(STORAGE_KEY, String(value));
  }, []);

  const enable = useCallback(() => persist(true), [persist]);
  const disable = useCallback(() => persist(false), [persist]);
  const toggle = useCallback(() => persist(!devMode), [persist, devMode]);

  return <DevModeContext.Provider value={{ devMode, enable, disable, toggle }}>{children}</DevModeContext.Provider>;
}

export function useDevMode() {
  const ctx = useContext(DevModeContext);
  if (!ctx) throw new Error("useDevMode 는 DevModeProvider 안에서만 사용하세요.");
  return ctx;
}
